import React from 'react';
import './AdminUsers.scss';
import AdminTableUsersMain from "./AdminTableUsersMain/AdminTableUsersMain";


const AdminUsers = (props) => {
    
   
        const {dispatch} = props;
        const view = props.viewUsers;
        if(view) {
            return (
            
                <div className="AdminUsers">
                        <AdminTableUsersMain 
                        adminUsersState = {props.adminUsersState}
                        dispatch={dispatch}
                        />
                        {/*<AdminView />*/}
                        
                        
    
    
                    
                </div>
            )
        } else return null;
        

    
}
export default AdminUsers;